import React from 'react';
import { steps } from '../mock';
import { ArrowRight } from 'lucide-react';

export default function HowItWorks() {
  return (
    <section id="how" className="py-16 lg:py-24 bg-white border-y-2 border-[#2C3E50]">
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <div className="text-center max-w-2xl mx-auto">
          <span className="text-[#F4B93E] uppercase tracking-[0.25em] font-black text-xs bg-[#2C3E50] px-3 py-1 rounded-full">How it works</span>
          <h2 className="mt-4 text-3xl lg:text-5xl font-black text-[#2C3E50] leading-[1.05]">
            Three simple steps to <span className="text-[#E64B2B]">brighter report cards.</span>
          </h2>
        </div>

        <div className="mt-14 grid md:grid-cols-3 gap-8 relative">
          {steps.map((s, i) => (
            <div key={s.n} className="relative">
              <div className="bg-[#FFF8EC] rounded-2xl border-2 border-[#2C3E50] p-7 paper-shadow-sm h-full">
                <div className="flex items-center justify-between mb-4">
                  <div className="text-5xl font-black text-[#4FB3B8]" style={{ fontFamily: 'Fraunces, serif' }}>{s.n}</div>
                  <div className="w-10 h-10 rounded-full bg-[#F4B93E] border-2 border-[#2C3E50] flex items-center justify-center font-black text-[#2C3E50]">
                    {i+1}
                  </div>
                </div>
                <h3 className="text-2xl font-black text-[#2C3E50]">{s.title}</h3>
                <p className="mt-2 text-[#2C3E50]/75 font-medium leading-relaxed">{s.desc}</p>
              </div>
              {i < steps.length - 1 && (
                <ArrowRight className="hidden md:block absolute -right-6 top-1/2 -translate-y-1/2 text-[#E64B2B]" size={32} strokeWidth={3} />
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
